import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel, Pagination } from "swiper/modules";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import RichText from "components/media-carousel/content";
import Image from "components/image";
import ButtonLink from "components/button-link";

const GalleryWithText = ({ data }) => {
	const { text, images, icons, buttons } = data;

	const swiperSettings = {
		modules: [Navigation, Mousewheel, Pagination],
		speed: 1500,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		navigation: {
			nextEl: ".right-arrow",
			prevEl: ".left-arrow",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		slidesPerView: 1,
		spaceBetween: 0,
	};

	return (
		<div className="standard-section-width my-5 flex flex-col md:max-h-144 md:gap-8 md:flex-row items-stretch">
			<div className="md:w-1/2 md:p-6 flex flex-col justify-center md:gap-4 gallery-with-text">
				<RichText data={text} />
				{icons?.length > 0 && (
					<div className="flex flex-wrap  gap-3 md:gap-2 sm:py-0 py-3 w-full xxl:gap-4 mt-2">
						{icons.map((item, idx) => (
							<div key={idx} className="flex bg-cream p-1 justify-center items-center">
								{item.icon && <Image image={item.icon} className="w-3" />}
								{item.text && <span className="text-[11px] px-2 text-black">{item.text}</span>}
							</div>
						))}
					</div>
				)}
				{buttons?.length > 0 && (
					<div className="flex flex-col sm:flex-row w-full gap-4 my-5 md:mt-2">
						{buttons.map((item, idx) => (
							<div key={idx} className=" w-full xxl:w-2/5">
								<ButtonLink data={item} className=" !w-auto" />
							</div>
						))}
					</div>
				)}
			</div>

			<div className="md:w-1/2 w-full flex flex-col justify-center items-center">
				<div className="max-w-full">
					<Swiper {...swiperSettings} className="w-full">
						{images.map((img, index) => (
							<SwiperSlide key={index} className="w-full">
								<Image image={img} className="object-cover max-h-128" />
							</SwiperSlide>
						))}
						<div className="flex items-center justify-center z-20 mt-3 md:mt-5 md:gap-2">
							<button className="left-arrow">
								<Arrow className="rotate-180 md:scale-100 scale-75 !z-30 bg-grey/30 fill-black" />
							</button>
							<div className="swiper-pagination relative flex-center !w-auto !bottom-0"></div>
							<button className="right-arrow">
								<Arrow className="md:scale-100 scale-75 !z-30 fill-black bg-grey/30" />
							</button>
						</div>
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default GalleryWithText;